module.exports = __webpack_public_path__ + "img/78.64ac6ac1.jpg";